module.exports = __webpack_public_path__ + "img/item-blank.89c552a3.png";